const detectMob = () => {
    return ( window.innerWidth < 1024 );
}

export { detectMob }